import { FormControl, FormGroup, Validators } from '@angular/forms';

export enum DealType {
    INSTRUMENT_ONLY = 'instrument-only',
    STANDARD_DEAL = 'standard-deal'
}

export interface DealTypeForm {
    dealType: DealType;
}

export interface DealTypeFormGroup {
    dealType: FormControl<DealType | null>;
}

export const createDealTypeFormGroup = (): FormGroup<DealTypeFormGroup> => {
    return new FormGroup<DealTypeFormGroup>({
        dealType: new FormControl<DealType | null>(null, Validators.required)
    });
};
